import React from "react"
import {Route} from "react-router-dom"

import AppContainer from "@irati/ui/src/AppContainer"
import {PartialRoute} from "@irati/utils/history/routing"
import {ANNUALLEAVEPURCHASE} from "@irati-web/app/src/routeConfig"
import {LangLoader} from "@irati/utils/lang"

import benefitPage from "./benefitPage"

export const ctwURL = "cycle-to-work"
export const heURL = "home-electronics"
export const alpURL = "annual-leave-purchase"

const benefitRoutes = ({path}) => {
  return (
    <LangLoader buckets={[ANNUALLEAVEPURCHASE]}>
      <Route
        path={path}
        render={() => (
          <AppContainer>
            <PartialRoute
              match={path}
              exact
              path={`/${ctwURL}`}
              component={benefitPage}
              componentProps={{benefit: "ctw"}}
              title="Cycle to Work"
            />
            <PartialRoute
              match={path}
              exact
              path={`/${heURL}`}
              component={benefitPage}
              componentProps={{benefit: "he"}}
              title="Home & Electronics"
            />
            <PartialRoute
              match={path}
              exact
              path={`/${alpURL}`}
              component={benefitPage}
              componentProps={{benefit: "alp"}}
              title="Annual Leave Purchase"
            />
          </AppContainer>
        )}
      />
    </LangLoader>
  )
}

export default benefitRoutes
